import template from './sw-cms-block-image-simple-grid.html.twig';
import './sw-cms-block-image-simple-grid.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
